import React from 'react';
import css from './RenderInvisibles.modules.css';
export function splitAndInsert(haystack, needle, replacement) {
    if (typeof haystack !== 'string') {
        return [haystack];
    }
    return haystack
        .split(needle)
        .flatMap(function (piece, index, array) {
        if (index === array.length - 1) {
            return [piece];
        }
        return [piece, replacement];
    })
        .filter(function (piece) { return piece !== ''; });
}
function Invisible(_a) {
    var children = _a.children;
    return React.createElement("span", { className: css.invisible }, children);
}
export default function HandleInvisible(_a) {
    var text = _a.text, showInvisible = _a.showInvisible;
    var pieces = [text];
    // denote appropriately
    if (showInvisible) {
        pieces = pieces
            .flatMap(function (piece) { return splitAndInsert(piece, '\r', React.createElement(Invisible, null, "\\r")); })
            .flatMap(function (piece) { return splitAndInsert(piece, '\n', React.createElement(React.Fragment, null,
            React.createElement(Invisible, null, "\\n"),
            React.createElement("br", null))); })
            .flatMap(function (piece) { return splitAndInsert(piece, '\t', React.createElement(Invisible, null, "\\t")); })
            .flatMap(function (piece) { return splitAndInsert(piece, ' ', React.createElement(Invisible, null, "\u2022")); });
    }
    else {
        pieces = pieces.flatMap(function (piece, index) { return splitAndInsert(piece, '\n', React.createElement("br", { key: 'br' + index })); });
    }
    pieces = pieces.map(function (piece) {
        if (typeof piece === 'string') {
            return piece.replaceAll('\n', '').replaceAll('\r', '');
        }
        return piece;
    });
    return (React.createElement(React.Fragment, null, pieces.map(function (piece, i) { return (React.createElement("span", { key: i }, piece)); })));
}
